module.exports = __webpack_public_path__ + "static/media/icone_pet.2700b4e2.svg";